<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon> Ver permiso 
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-container grid-list-md class="pt-0">
          <v-layout row wrap>
            <v-flex xs12>
              <h3><strong>Número:</strong> {{ permiso.numero }}</h3>
            </v-flex>
            <v-flex xs12>
              <h3><strong>Servidor público::</strong> {{ permiso.nombres }}</h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_estado==16">
              <h3><strong>Justificación del rechazo:</strong> {{ permiso.justificacion }}</h3>
            </v-flex>
            <v-flex xs12>
              <h3>
                <strong>Tipo de papeleta:</strong> {{ permiso.tipo_permiso }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
              <h3>
                <strong>Lugar de atencion:</strong> {{ permiso.lugar_atencion }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '87'">
              <h3><strong>Lugar de comisión :</strong> {{ permiso.lugar }}</h3>
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == '87' ||
                  permiso.id_tipo_permiso == '96'
              "
            >
              <h3><strong>Motivo:</strong> {{ permiso.motivo }}</h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <h3>
                <strong>Fecha de nacimiento:</strong>
                {{ permiso.fecha_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <h3>
                <strong>Hora de nacimiento:</strong>
                {{ permiso.hora_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <h3>
                <strong>Fecha de fallecimiento:</strong>
                {{ permiso.fecha_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <h3>
                <strong>Hora de fallecimiento:</strong>
                {{ permiso.hora_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '12'">
              <h3>
                <strong>Fecha de matrimonio:</strong>
                {{ $moment(permiso.fecha_nac_muerte).format("DD-MM-YY") }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_estado==9">
              <h3 class="texto">
                <strong>Motivo de la anulación:</strong> {{ permiso.justificacion }}
              </h3>
            </v-flex>
            <!--	
							<v-flex xs12 v-if="(permiso.rechazo!= null || permiso.rechazo!='' ||  permiso.rechazo )&& permiso.id_estado==16" >
							<h3 v-if="permiso.rechazo!= null || permiso.rechazo!='' ||  permiso.rechazo"><strong>Motivo rechazo:</strong> {{permiso.rechazo }}</h3>
						</v-flex> -->
          </v-layout>
          <h3><strong>Detalles de papeleta</strong></h3>
      
         
          <!--permiso 24-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles"
                class="elevation-1"
                hide-actions
                :headers="headers"
                v-if="permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <!-- <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td> -->
                  <td class="text-xs-center">{{ permiso.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

        
        </v-container>
      </v-card-text>
      <v-card-text>
        <h2><strong>Seguimiento de papeleta</strong></h2>
        <v-layout>
          <v-flex xs12>
            <v-data-table
              :items="detalle_seguimiento"
              class="elevation-1"
              hide-actions
              :headers="headers_detalle"
            >
              <template v-slot:items="props"> 
                <td class="text-xs-center">{{ props.item.fecha_registro }}</td>
                <td class="text-xs-center">{{ props.item.estado == 'Aprobado. Inmediato Superior Jerárquico' ? 'Aprobado' : props.item.estado }}</td>
                <td class="text-xs-center">{{ props.item.usuario }}</td>
                <td class="text-xs-center">{{ props.item.jefe }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" type="submit" @click.prevent="close()"
          ><v-icon>clear</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  components: {},
  mixins: [validate],
  props: ["item"],
  mounted() {
    this.$bus.$on("openDialogVerPermisoJefe", item => {
      this.permiso = item;
      this.total_horas();

      this.cargarDetallesPermiso();
      this.getDetallePermiso(item.id_permiso);
      this.verPermisosCompensacion(item.id_permiso);
      this.getDetalleSeguimiemto(item.id_permiso);
      this.dialog = true;
    });
  },
  data() {
    return {
      usuario: this.$storage.get("user"),
      dialog: false,
      permiso: {
        permiso: {
          motivo: ""
        }
      },
      permiso_compensacion: [],
      permiso_detalles: [],
      permiso_detalle: [],
      motivo2: [],
      vDetallePermisos: {},
      permiso_detalles2: [],
      total_horas_acomuladas: 0,
      loading: false,
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
     
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      horas_solicitadas: 0,
      horas_solicitadas_comp: 0,
      detalle_seguimiento: [],
      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario destinatario",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  methods: {
    async cargarDetallesPermiso() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			    query{
					vPermisosPorFuncionarios(id_permiso:"${this.permiso.id_permiso}"){
					rows{
						id_permiso
							id_persona
							nombres
							numero
							fecha_desde
							fecha_emision
							tipo_permiso
							fecha_retorno
							estado_permiso
							nro_dias
							hora_desde
							hora_hasta
							id_lugar
							lugar_atencion
							fecha_nac_muerte
							hora_nac_muerte
							tipo_nac_muerte
							rango_horario
							rechazo
							horas_permiso
							id_tipo_permiso
							compensa_tolerancia
							permiso{
							id
							motivo
							id_tipo_permiso
							ruta_archivo
							tipo_permiso{
								id
								id_parametro_elaborado
							}
							fecha_permiso
							numero
							fecha_registro
							id_estado
							lugar        
							
							estado{
								descripcion
							}
							
							
							}
						}
			}
				}
              `
        });

        this.permiso_detalles2 = respuesta.vPermisosPorFuncionarios.rows;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
         let respuesta 
        let res 
        respuesta= await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `,
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
         res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `,
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });

        this.permiso_compensacion = respuesta.runQuery.respuesta;
        this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
			query{
              vDetallePermisos(lista_estados:"9,6,7,16,21,75",id_permiso:${id}){
                rows{
                  id
                  id_permiso
                  id_estado_detalle
                  fecha_desde
                  fecha_hasta
                  fecha_desde_compensa
                  hora_desde
                  hora_hasta
                  horas_compensa
                  fecha_permiso
				  total_dias
				  rango_horario
                }
              }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

      } catch (error) {
        console.log(error);
      }
    },
    // async verSeguimientoDetalle(id_permiso) {
    //   let id_estado="16";
    //     try {
    //     let res = await this.$service.graphql({

    //       query: `query{
    // 						seguimientoDetalles(id_permiso:${id_permiso},id_estado:${id_estado}){
    // 							rows{
    // 							id_permiso
    // 							id_persona
    // 							id_estado
    // 							motivo

    // 							}
    // 						}
    // 					}
    // 				`,
    //     });

    //     this.motivo2 = res.seguimientoDetalles.rows;
    //     console.log('SSSSSSSSSSSS',this.motivo2 );
    //     //console.log(this.seguimiento_detalle);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    aprobarRechazar(id_permiso, id_estado) {
      this.loading = true;
      this.$service
        .graphql({
          query: `
					query {
						apruebaControlPermiso(id_tipo_permiso: ${id_permiso}, id_estado: ${id_estado}, id_jefe: ${this.getUserId()}){
							mensaje
						}
					}
				`
        })
        .then(response => {
          if (response.apruebaControlPermiso.mensaje === "ok") {
            this.$message.success();
            this.$bus.$emit("closeDialog");
            this.close();
          } else {
            this.$message.error(response.apruebaControlPermiso.mensaje);
            this.close;
          }
        });
      this.loading = false;
    },
    sumar_horas(permiso_detalles) {
      let total = 0;
      permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas = total;
    },
    sumar_horas_compensa(permiso_detalles) {
      let total_comp = 0;
      permiso_detalles.forEach(item => {
        total_comp +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas_comp = total_comp;
    },
    // sumar_horas (permiso_detalles) {
    // 	let total = 0
    // 	console.log('id_permiso::::'+permiso_detalles)
    // 	permiso_detalles.forEach(item => {
    // 		total += this.$moment(item.fecha_hasta+' '+item.hora_hasta).diff(item.fecha_desde+' '+item.hora_desde, 'minutes') / 60
    // 	})
    // 	this.horas_solicitadas = total
    // //sumar_horas () {
    // 	// let total = 0
    // 	// permiso_detalles.forEach(item => {
    // 	// 	total += this.$moment(item.fecha_hasta+' '+item.hora_hasta).diff(item.fecha_desde+' '+item.hora_desde, 'minutes') / 60
    // 	// })
    // 	// this.horas_solicitadas = total
    // },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/dialogs/VerPermisoJefe.vue